import axios from "../../Axios/axiosConfig";

export class ControlUnitService {
    baseUrl;

    constructor(serverUrl) {
        this.baseUrl = serverUrl;
    }

    // async getControlUnitsData() {
    //     return axios.get(`${this.baseUrl}/api/control-units`)
    //         .then(response => {
    //             return response.data.map(controlUnit => {
    //                 return {...controlUnit, siteName: controlUnit.site?.name};
    //             })
    //         })
    //         .catch(error => {
    //             console.error(error);
    //             return [];
    //         });
    // }

    async getControlUnitsData(rsqlQuery = null, sortQuery = null, pageIndex = 0, pageSize = 18) {
        const params = {
            page: pageIndex,
            size: pageSize
        };
        if (rsqlQuery) {
            params.searchQuery = rsqlQuery;
        }
        if (sortQuery) {
            params.sortQuery = sortQuery;
        }

        return axios.get(`${this.baseUrl}/api/control-units`, {params})
            .then(response => {
                if (!response || !response.data) {
                    console.error("Invalid response or missing data property");
                    return {content: [], totalElements: 0};
                }
                return {
                    data: {
                        ...response.data,
                        content: Array.isArray(response.data.content)
                            ? response.data.content.map(controlUnit => ({
                                siteName: controlUnit.site?.name,
                                ...controlUnit,

                            }))
                            : []
                    }
                }
            })
            .catch(error => {
                console.error(error);
                return {content: [], totalElements: 0};
            });
    }

    getSingleControlUnitData = (controlUnitId) => {
        return axios.get(`${this.baseUrl}/api/control-units/${controlUnitId}/from-list`);
    }

    getControlUnitDetails = (controlUnitId) => {
        return axios.get(`${this.baseUrl}/api/control-units/${controlUnitId}`);
    }

    getVmaStatus = (controlUnitId, vmaUuid) => {
        return axios.get(`${this.baseUrl}/api/control-units/${controlUnitId}/vma/${vmaUuid}/state/pairing`);
    }

    getDownloadStatus = (controlUnitId, vmaUuid) => {
        return axios.get(`${this.baseUrl}/api/control-units/${controlUnitId}/vma/${vmaUuid}/state/download`);
    }

    getSwitchStatus = (controlUnitId, vmaUuid) => {
        return axios.get(`${this.baseUrl}/api/control-units/${controlUnitId}/vma/${vmaUuid}/state/switch`);
    }

    pairVma = (controlUnitId, vmaUuid) => {
        return axios.post(`${this.baseUrl}/api/control-units/${controlUnitId}/vma/${vmaUuid}/pair`);
    }

    pairVmaBySerialNumber = (controlUnitId, vmaUuid, vmaSerialNumber) => {
        return axios.post(`${this.baseUrl}/api/control-units/${controlUnitId}/vma/${vmaUuid}/pair`, {vmaSerial: vmaSerialNumber});
    }

    unpairVma = (controlUnitId, vmaUuid) => {
        return axios.post(`${this.baseUrl}/api/control-units/${controlUnitId}/vma/${vmaUuid}/unpair`);
    }

    addVma = (controlUnitId, name, model) => {
        return axios.post(`${this.baseUrl}/api/control-units/${controlUnitId}/vma`,
            {
                name: name,
                modbusModel: model
            })
    }

    editVma = (controlUnitId, vmaUuid, payload) => {
        return axios.post(`${this.baseUrl}/api/control-units/${controlUnitId}/vma/${vmaUuid}`, payload);
    }


    deleteVma = (controlUnitId, vmaUuid) => {
        return axios.delete(`${this.baseUrl}/api/control-units/${controlUnitId}/vma/${vmaUuid}`);
    }

    deleteWaterSystem = (controlUnitId, waterSystemId) => {
        return axios.delete(`${this.baseUrl}/api/control-units/${controlUnitId}/water-systems/${waterSystemId}`);
    }

    downloadVmaFirmware = (controlUnitId, vmaUuid) => {
        return axios.post(`${this.baseUrl}/api/control-units/${controlUnitId}/vma/${vmaUuid}/firmware/download`);
    }

    switchVmaFirmware = (controlUnitId, vmaUuid) => {
        return axios.post(`${this.baseUrl}/api/control-units/${controlUnitId}/vma/${vmaUuid}/firmware/switch`);
    }

    addWaterSystem = (controlUnitId) => {
        return axios.post(`${this.baseUrl}/api/control-units/${controlUnitId}/water-systems`);
    }

    downloadSshKey = (controlUnitId) => {
        return axios.get(`${this.baseUrl}/api/credentials/${controlUnitId}/ssh-key`, {
            responseType: 'blob'
        });
    }

    updateControlUnitDetails = (controlUnitId, details) => {
        return axios.post(`${this.baseUrl}/api/control-units/${controlUnitId}`, details);
    }

    getSshTunnel = (controlUnitId) => {
        return axios.post(`${this.baseUrl}/api/ssh_tunnel/active`, {controlUnitId: controlUnitId});
    }

    getSshTunnelStatus = (sshTunnelId) => {
        return axios.get(`${this.baseUrl}/api/ssh_tunnel/${sshTunnelId}`);
    }

    openSshTunnel = (controlUnitId, userEmail, pathValue) => {
        return axios.post(`${this.baseUrl}/api/ssh_tunnel/open`, {
            controlUnitId: controlUnitId,
            description: `Created by the user ${userEmail} for a control unit with an id of ${controlUnitId}`,
            filePath: pathValue === '' ? null : pathValue
        });

    }

    closeSshTunnel = (tunnelId) => {
        return axios.post(`${this.baseUrl}/api/ssh_tunnel/close`, {tunnelId: tunnelId});
    }

    getModbusModels = () => {
        return axios.get(`${this.baseUrl}/api/control-units/vma/modbus-models`);
    }

    resetToFactoryDefaults = (controlUnitId) => {
        return axios.post(`${this.baseUrl}/api/control-units/${controlUnitId}/facdef`);
    }

    resetServices = (controlUnitId) => {
        return axios.post(`${this.baseUrl}/api/control-units/${controlUnitId}/reset`);
    }

    rebootDevice = (controlUnitId) => {
        return axios.post(`${this.baseUrl}/api/control-units/${controlUnitId}/reset-os`);
    }


    isControlUnitDataChanged = (controlUnitId, configurationVersion, stateVersion) => {
        return axios.get(`${this.baseUrl}/api/control-units/${controlUnitId}/has-changed?configurationVersion=${configurationVersion}&stateVersion=${stateVersion}`);
    }

    getNote = (controlUnitId) => {
        return axios.get(`${this.baseUrl}/api/control-units/${controlUnitId}/note`);
    }

    updateNote = (controlUnitId, noteText) => {
        return axios.put(`${this.baseUrl}/api/control-units/${controlUnitId}/note`, { note: noteText });
    }
}
